import { useQuery } from '@tanstack/react-query';
import {
  EncounterSummary,
  EncounterSummaryType,
  MagicdocsSummaryPhase,
} from 'src/models';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetSummaryListParams = {
  encounterId?: string;
  encounterPhase?:
    | EncounterSummary['encounter_phase']
    | MagicdocsSummaryPhase
    | null;
  serviceRequestId?: string;
  type?: EncounterSummaryType | 'magicdocs';
  page?: number;
  pageSize?: number;
};

export type GetSummaryListResponse<
  T extends string | Array<any> | Record<string, any> = string,
> = {
  summaries: EncounterSummary<T>[];
};

export const useGetSummaryList = <
  T extends string | Array<any> | Record<string, any> = string,
>(
  params: UseGetSummaryListParams,
  options?: UseQueryOverrideOptions<GetSummaryListResponse<T>>
) => {
  const {
    encounterId,
    encounterPhase,
    serviceRequestId,
    type,
    page,
    pageSize,
  } = params;

  return useQuery({
    ...options,
    queryKey: ['summaryList', params],
    queryFn: () =>
      ambientApi
        .get<GetSummaryListResponse<T>>('/summaries', {
          params: {
            encounter_id: encounterId,
            encounter_phase: encounterPhase,
            service_request_id: serviceRequestId,
            type,
            page,
            page_size: pageSize,
          },
        })
        .then((res) => res.data),
  });
};
